/* Diesel inline quick-add panel: open/close + size/length selection + variant
   resolution + AJAX add-to-bag. Shared by the PLP grid, search grid, and the PDP
   "You may also like" recommendations. Delegated on document so it survives
   section re-renders and works for panels injected later (e.g. the async
   <product-recommendations> fetch on the PDP). Markup/styles live in
   snippets/diesel-quick-add-panel.liquid. */
(function () {
  if (window.__dieselQuickAddBound) return;
  window.__dieselQuickAddBound = true;

  // On mobile the panel is a bottom sheet over a scrim (see the snippet's
  // stylesheet), and uk.diesel.com locks page scroll behind it. The class is set
  // on every open — including desktop hover-opens — and the CSS that acts on it
  // is inside the mobile media query, so desktop is unaffected.
  function syncLock() {
    document.body.classList.toggle('dqa-locked', !!document.querySelector('.card-wrapper.dqa-open'));
  }

  function openCard(trigger) {
    var wrap = trigger.closest('.card-wrapper');
    if (!wrap) return;
    // Exclusive: every sheet is pinned to the same spot at the bottom of the
    // viewport on mobile, so two open at once would stack. Desktop relied on the
    // hover handler to close the previous card, which no longer runs on touch.
    var open = document.querySelectorAll('.card-wrapper.dqa-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== wrap) closeCard(open[i]);
    }
    wrap.classList.add('dqa-open');
    trigger.setAttribute('aria-expanded', 'true');
    syncLock();
  }
  function closeCard(wrap) {
    if (!wrap) return;
    wrap.classList.remove('dqa-open');
    var t = wrap.querySelector('[data-quickadd-open]');
    if (t) t.setAttribute('aria-expanded', 'false');
    syncLock();
  }

  function setDisabled(cell, off) {
    cell.disabled = !!off;
    if (off) {
      cell.classList.add('is-soldout');
      cell.setAttribute('aria-disabled', 'true');
      if (cell.classList.contains('is-selected')) {
        cell.classList.remove('is-selected');
        cell.setAttribute('aria-pressed', 'false');
      }
    } else {
      cell.classList.remove('is-soldout');
      cell.removeAttribute('aria-disabled');
    }
  }

  function resolve(panel) {
    var data;
    try { data = JSON.parse(panel.querySelector('[data-qa-variants]').textContent); }
    catch (e) { return; }
    var hasLength = panel.hasAttribute('data-qa-has-length');
    var selSize = panel.querySelector('.dqa-cell[data-qa-dim="size"].is-selected');
    var selLen = panel.querySelector('.dqa-cell[data-qa-dim="length"].is-selected');
    var svSel = selSize ? selSize.getAttribute('data-qa-value') : null;
    var lvSel = selLen ? selLen.getAttribute('data-qa-value') : null;

    // Cross-filter: disable size values with no available variant for the
    // chosen length, and length values with none for the chosen size.
    panel.querySelectorAll('.dqa-cell[data-qa-dim="size"]').forEach(function (c) {
      var sv = c.getAttribute('data-qa-value');
      var ok = data.some(function (v) {
        return v.size === sv && v.available && (!hasLength || !lvSel || v.length === lvSel);
      });
      setDisabled(c, !ok);
    });
    if (hasLength) {
      panel.querySelectorAll('.dqa-cell[data-qa-dim="length"]').forEach(function (c) {
        var lv = c.getAttribute('data-qa-value');
        var ok = data.some(function (v) {
          return v.length === lv && v.available && (!svSel || v.size === svSel);
        });
        setDisabled(c, !ok);
      });
    }

    // Resolve variant. First AVAILABLE match wins (defaults colour to first).
    var idInput = panel.querySelector('[data-qa-variant-id]');
    var addBtn = panel.querySelector('[data-qa-add]');
    var ready = selSize && (!hasLength || selLen);
    var match = null;
    if (ready) {
      match = data.find(function (v) {
        return v.size === svSel && (!hasLength || v.length === lvSel) && v.available;
      });
    }
    if (match) {
      idInput.value = match.id;
      idInput.disabled = false;
      addBtn.disabled = false;
      addBtn.setAttribute('aria-disabled', 'false');
    } else {
      idInput.value = '';
      idInput.disabled = true;
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
    }
  }

  // Hover-to-open is DESKTOP ONLY, and only for a real pointer.
  //
  // A tap emits mouseover BEFORE click. Unconditionally, that broke touch
  // completely: the mouseover opened the sheet, whose full-screen scrim carries
  // data-quickadd-close and so instantly covered the tap point, and the click
  // that followed landed on the scrim and closed it again — the panel appeared
  // never to open at all. It also meant a narrow desktop window (mobile layout,
  // mouse attached) opened the sheet on hover, where it should need a click.
  //
  // Checked per event rather than once at load so resizing the window switches
  // behaviour without a reload.
  var canHoverOpen = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  document.addEventListener('mouseover', function (e) {
    if (!canHoverOpen.matches) return;
    var trigger = e.target.closest('[data-quickadd-open]');
    if (trigger) openCard(trigger);
    var open = document.querySelectorAll('.card-wrapper.dqa-open');
    for (var i = 0; i < open.length; i++) {
      if (!open[i].contains(e.target)) closeCard(open[i]);
    }
  });

  function updateCartCount(count) {
    var link = document.querySelector('.haction--cart');
    if (!link) return;
    var sup = link.querySelector('.haction__count');
    if (count > 0) {
      if (!sup) {
        sup = document.createElement('sup');
        sup.className = 'haction__count';
        link.appendChild(sup);
      }
      sup.textContent = count;
      // Restart the confirmation pop even on consecutive adds.
      sup.classList.remove('dqa-pop');
      void sup.offsetWidth;
      sup.classList.add('dqa-pop');
    } else if (sup) {
      sup.remove();
    }
  }

  function addToCart(btn) {
    var panel = btn.closest('[data-quickadd-panel]');
    var input = panel.querySelector('[data-qa-variant-id]');
    var id = input && input.value;
    if (!id || btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';
    btn.setAttribute('aria-disabled', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function reset() {
      btn.dataset.loading = '';
      btn.setAttribute('aria-disabled', 'false');
      btn.classList.remove('dqa-add--done');
      var addLabel = btn.getAttribute('data-add-label');
      if (addLabel) btn.textContent = addLabel;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        // The Diesel cart flyout is now the add-to-bag confirmation (matches
        // uk.diesel.com): close the "+" panel and open the drawer with the item.
        reset();
        closeCard(panel.closest('.card-wrapper'));
        if (window.dieselCartDrawerOpen) {
          window.dieselCartDrawerOpen();
        } else {
          // Fallback: brief inline confirmation if the drawer script isn't present.
          btn.classList.add('dqa-add--done');
          var addedLabel = btn.getAttribute('data-added-label');
          if (addedLabel) btn.textContent = addedLabel;
          setTimeout(function () { btn.classList.remove('dqa-add--done'); reset(); }, 1200);
        }
      })
      .catch(reset);
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-qa-add]');
    if (addBtn) {
      e.preventDefault();
      if (!addBtn.disabled && addBtn.getAttribute('aria-disabled') !== 'true') addToCart(addBtn);
      return;
    }

    // Touch fallback: tap "+" to open, back arrow to close (no hover on touch).
    var openBtn = e.target.closest('[data-quickadd-open]');
    if (openBtn) { openCard(openBtn); return; }

    var backBtn = e.target.closest('[data-quickadd-close]');
    if (backBtn) { closeCard(backBtn.closest('.card-wrapper')); return; }

    var cell = e.target.closest('.dqa-cell');
    if (cell && !cell.disabled) {
      var panel = cell.closest('[data-quickadd-panel]');
      var dim = cell.getAttribute('data-qa-dim');
      panel.querySelectorAll('.dqa-cell[data-qa-dim="' + dim + '"]').forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      cell.classList.add('is-selected');
      cell.setAttribute('aria-pressed', 'true');
      resolve(panel);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.card-wrapper.dqa-open');
      if (open) closeCard(open);
    }
  });
})();
